import { render, staticRenderFns } from "./usual.vue?vue&type=template&id=fda36e2c&"
import script from "./usual.vue?vue&type=script&lang=js&"
export * from "./usual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports